<span [class]="'stat-item ' + getIconClass()">{{ getValue() }}</span>
